import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export function UWReviewHeader({
  title,
  titleFontSize,
  imageSize = 160,
}: {
  title: string;
  titleFontSize?: number;
  imageSize?: number;
}) {
  return (
    <>
      <Box
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        component={(props) => (
          <img
            width={imageSize}
            height={imageSize}
            alt="Review pending"
            src={"/images/underwriting-review/pending.webp"}
            {...props}
          />
        )}
      />
      <Box mb={5}>
        <Typography
          data-testid="decline-property-header"
          variant="h3"
          fontSize={titleFontSize}>
          {title}
        </Typography>
      </Box>
    </>
  );
}
